import React from "react";
import "./skills.scss";
import { motion } from "framer-motion";
// eslint-disable-next-line
import { data, images } from "../../constants";

const SkillCard = ({ program: { imgUrl, title } }) => (
  <div className="p-2 justify-center m-1">
    <img
      src={imgUrl}
      alt={title}
      className="w-14 h-14 rounded-full m-auto lg:w-24 lg:h-24"
    />
    <p className="text-center mt-1 font-skills-title t">{title}</p>
  </div>
);

const Skills = () => (
  <div id="skills" className="mainContainerSkills overflow-auto w-screen">
    <div className="header font-face-nh">SKILLS</div>

    <motion.div
      className="grid grid-cols-2 mt-1 ml-3 mr-3 justify-evenly programming lg:flex lg:mt-[8vh] lg:mr-[8vw] lg:ml-[8vw]"
      initial="hidden"
      whileInView="visible"
      viewport={{ once: false, amount: 0.0 }}
      transition={{ delay: 0.5, duration: 2.0 }}
      variants={{
        hidden: { opacity: 0, z: 100 },
        visible: { opacity: 1, z: 0 },
      }}
    >
      {data.programming.map((program) => (
        <SkillCard program={program} key={program.title} />
      ))}
    </motion.div>

    <motion.div
      className="grid grid-cols-2 mt-1 ml-3 mr-3 justify-evenly backend lg:flex lg:mr-[8vw] lg:ml-[8vw] lg:mt-[5vh]"
      initial="hidden"
      whileInView="visible"
      viewport={{ once: false, amount: 0.0 }}
      transition={{ delay: 0.0, duration: 2.0 }}
      variants={{
        hidden: { opacity: 0.05, z: 100 },
        visible: { opacity: 1, z: 0 },
      }}
    >
      {data.backend.map((program) => (
        <SkillCard program={program} key={program.title} />
      ))}
    </motion.div>

    <motion.div
      className="grid grid-cols-2 mt-1 ml-3 mr-3 justify-evenly framework lg:flex lg:mr-[8vw] lg:ml-[8vw] lg:mt-[5vh]"
      initial="hidden"
      whileInView="visible"
      viewport={{ once: false, amount: 0.0 }}
      transition={{ delay: 0.5, duration: 3.0 }}
      variants={{
        hidden: { opacity: 0, y: 30 },
        visible: { opacity: 1, y: 0 },
      }}
    >
      {data.framework.map((program) => (
        <SkillCard program={program} key={program.title} />
      ))}
    </motion.div>
  </div>
);

export default Skills;
